import { render, staticRenderFns } from "./NewsSurvey.vue?vue&type=template&id=b8763a86"
import script from "./NewsSurvey.vue?vue&type=script&lang=js"
export * from "./NewsSurvey.vue?vue&type=script&lang=js"
import style0 from "./NewsSurvey.vue?vue&type=style&index=0&id=b8763a86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports